module.exports = __webpack_public_path__ + "img/clock-three.bd04d6ff.svg";